import { IBillType } from '../../types'
import {TApiEnums} from '../../../services/_common'

export function parseBillTypes(response: TApiEnums): IBillType[] {
    return response.entities.map((item) => ({
        id: item['@id'],
        text: item.text,
    }))
}